import { render, staticRenderFns } from "./RegistrationIntegrityFlow.vue?vue&type=template&id=da15b9e2&scoped=true&"
import script from "./RegistrationIntegrityFlow.vue?vue&type=script&lang=js&"
export * from "./RegistrationIntegrityFlow.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationIntegrityFlow.vue?vue&type=style&index=0&id=da15b9e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da15b9e2",
  null
  
)

export default component.exports